import { useGetQuantifyFormulaDisplayName } from '@modules/quantify/hooks/useGetQuantifyFormulaDisplayName';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';

interface useGetMeasuredAsDisplayNameParams {
  formulaID?: string;
  shouldIncludeGroupByName?: boolean;
}

export function useGetMeasuredAsDisplayName({
  formulaID,
  shouldIncludeGroupByName,
}: useGetMeasuredAsDisplayNameParams = {}) {
  const measuredAsCriteria = useQuantifyStore(
    ({ query }) => query.measuredAsCriteria,
  );
  const { formulaDisplayName } = useGetQuantifyFormulaDisplayName({
    formulaID,
    shouldIncludeGroupByName,
  });

  if (measuredAsCriteria) {
    return `${formulaDisplayName} of ${measuredAsCriteria.displayName}`;
  }

  return `${formulaDisplayName} of Feedback Records`;
}
